import React from 'react';
import ReactECharts from 'echarts-for-react';

const IRIMedianChart = ({ IRI_design1_US, IRI_design2_US, analysisPeriod, design1title, design2title }) => {

  if (!IRI_design1_US || !IRI_design2_US || IRI_design1_US.length === 0 || IRI_design2_US.length === 0) {
    return <div>Loading...</div>; // Or any other loading indicator
  }

  const X = Array.from({ length: analysisPeriod }, (_, i) => i + 1);

  // Define series names, ensuring they are not undefined
  const design1Name = design1title || 'Design 1';
  const design2Name = design2title || 'Design 2';

  // Ensure the data arrays are of expected length
  const IRI_design1_data = IRI_design1_US.length === analysisPeriod ? IRI_design1_US : Array(analysisPeriod).fill(0);
  const IRI_design2_data = IRI_design2_US.length === analysisPeriod ? IRI_design2_US : Array(analysisPeriod).fill(0);

  // ECharts option configuration
  const option = {
    title: {
      text: 'IRI vs. Analysis Period',
      left: 'center',
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
      },
    },
    xAxis: {
      type: 'category',
      data: X,
      name: 'Analysis Period (Years)',
      nameLocation: 'middle',
      nameGap: 30,
          // Custom ticks to display
          axisTick: {
              show: false,
              interval: 5, // Ensure all ticks are shown
          },
          min: 0, // Set minimum value for x-axis
          max: 50, // Set maximum value for x-axis
          // Set the tick values explicitly
          axisLabel: {
              formatter: function (value) {
                  // Create custom ticks: 1, 5, 10, 15, ..., 50
                  const customTicks = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50];
                  return customTicks.includes(parseInt(value)) ? value : '';
              },
              interval: 0 // This will ensure every label is checked for formatting
          },
      },
    yAxis: {
        type: 'value',
        axisLine: {
            show: true, // Show the axis line with default color
        },
        axisTick: {
            show: true, // Show tick marks with default style
        },
      name: 'IRI (in/mile)',
      nameLocation: 'middle',
      nameGap: 50,
      axisLabel: {
        fontSize: 14,
      },
    },
    series: [
      {
        name: design1Name,
        type: 'line',
        data: IRI_design1_data,
        lineStyle: {
          color: 'rgba(0, 114, 188, 1)', // Equivalent to (0, 0.4470, 0.7410)
          width: 1.5,
        },
        showSymbol: false, // No circles on the line
      },
      {
        name: design2Name,
        type: 'line',
        data: IRI_design2_data,
        lineStyle: {
          color: 'rgba(217, 83, 25, 1)', // Equivalent to (0.8500, 0.3250, 0.0980)
          width: 1.5,
        },
        showSymbol: false, // No circles on the line
      },
    ],
    legend: {
      data: [design1Name, design2Name],
      top: '10%',
    },
    grid: {
      left: '10%',
      right: '10%',
      bottom: '15%',
      containLabel: true,
    },
  };

  return <ReactECharts option={option} style={{ height: '500px', width: '100%' }} />;
};

export default IRIMedianChart;
